<template><div>
  <div style="width: 80%;margin: auto; background-color: antiquewhite;">
    <div style="padding: 30px;">
  <el-form :model="parameter" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
  <el-form-item label="选择部门" prop="departmentId">
    <el-select v-model="parameter.departmentId" placeholder="请选择部门">
      <el-option :label="item.name" :value="item.id" v-for="item in deptlist" :key="item.id"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="选择时间" prop="isWeeks">
  <el-select v-model="value" placeholder="考核年份"  @change="handChange">
          <el-option
            v-for="item in year"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="value3" placeholder="考核月份"  @change="handChange">
          <el-option
            v-for="item in moun"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="parameter.isWeeks" placeholder="第几周"  @change="handChange">
          <el-option
            v-for="item in week"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    <el-form-item label="工号" prop="workNumber">
      <el-input v-model="parameter.workNumber" oninput="value=value.replace(/[^0-9]/g, '');if(value.length>=6)value=value.slice(0,6)" @blur="workNumberChange"   maxlength="6" type="number" ></el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="userName">
      <el-input v-model="parameter.userName" oninput="if(value.length>=20)value=value.slice(0,20)"    maxlength="20"></el-input>
    </el-form-item>
    <el-form-item label="检查记录次数/上课出勤率" prop="classAttendence">
      <el-input v-model="parameter.classAttendence" placeholder="检查出勤及上课情况并提交检查记录/上课出勤率"  oninput="if(value.length>=7)value=value.slice(0,7)"   maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="监考次数/晚自习出勤率" prop="lateAttendence">
      <el-input v-model="parameter.lateAttendence" placeholder="晚自习值班、周周考监考次数/晚自习出勤率"  maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="检查宿舍次数/是否有通报" prop="dormitoryTimes">
      <el-input v-model="parameter.dormitoryTimes"  placeholder="检查宿舍次数/通报次数"  maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="联系学生并提交谈话记录" prop="talkRecord">
      <el-input v-model="parameter.talkRecord"  placeholder="谈话次数"  oninput="value=value.replace(/[^0-9]/g, '');if(value.length>=4)value=value.slice(0,4)"  type="number" ></el-input>
    </el-form-item>
    <el-form-item label="每月学生综合评价好评率" prop="feedback">
      <el-input v-model="parameter.feedback"  placeholder="每月学生综合评价好评率"   maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="是否有学生/家长投诉" prop="userComplaint">
      <el-input v-model="parameter.userComplaint"  placeholder="学生投诉次数/家长投诉次数"   maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="附件" prop="annexFileUrl">
      <el-upload
      :headers="headers"
  action="thu_api/performance/file"
  list-type="picture-card"
  :on-remove="handleRemove"
  :on-success="handSuccess"
  :file-list="fileList"
  :on-change="handleChange"
  :before-upload="beforeAvatarUpload"
  accept=".jpg,.jpeg,.png,.gif,.pdf">
  <i class="el-icon-plus"></i>
</el-upload>
<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input
  type="textarea"
  placeholder="请输入内容"
  v-model="parameter.remark"
  maxlength="255"
  show-word-limit
></el-input>
    </el-form-item>
    <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
  </el-form>
</div>
</div>
</div>
</template>
  <script>
    export default {
      data() {
        var check = (rule, value, callback) => { //判断带有/
          let va=value.split('/')
          if(va.length==1){
            callback(new Error("缺乏/"))
          }else if(va.length==2){
            if(this.isEmptyStr(va[0])||this.isEmptyStr(va[1])){
              callback(new Error("/左右不能为空")) 
            }else{
           this.checkVal(rule, value, callback,va)
            }
          }else{
            callback(new Error("/过多"))
          }
          console.log('value',value)
    }
    var checkWrited = (rule, value, callback) => {
      if(!(this.value==null||this.value3==''||this.parameter.isWeeks=='')){
            let kpidate=this.value+'-'+(this.value3>9?this.value3:'0'+this.value3)
            this.parameter.writeDate=kpidate
          }else{
            this.parameter.writeDate=null
            return false
          }
     if( this.parameter.writeDate!=null&&this.parameter.workNumber!=''&&this.parameter.workNumber!=null){
      this.axios.post("/performance/getWrited",this.parameter).then(res=>{
                console.log(res)
                if(res.data[1].total>0){
                  callback(new Error("本周已写"))
                }else{
                  callback()  
                }
              })
     }else{
      return false
     }
    }
    var checkOne = (rule, value, callback) => { //判断一个值且 必须带%
      if(!value.includes("%")){
              callback(new Error("未发现%"))
      }
      //     let reg = /^([0-9]\d{0,1}|100[%]{1}$)(\.\d{1,2})?%$/;
        let reg = /^(100|[0-9]{1,2})(\.\d{1,2})?%$/;
   if (!reg.test(value)) {
      callback(new Error("请填写正确的数值"))
   }
callback()
    }
        return {
          fileList:[],
          headers:{ 'token': localStorage.getItem('token')},
          dialogImageUrl: '',
          dialogVisible: false,
          week:[1,2,3,4],
          deptlist:[],
          value: '',
        value3: '',
        year:[],
        moun:[],
          parameter: {
            departmentId:2,
            workNumber:'',
            userName:'',
            classAttendence: '',
            lateAttendence: '',
            dormitoryTimes: '',
            talkRecord: '',
            feedback:'',
            userComplaint:'',
            writeDate:'',
            remark:'',
            isWeeks:'',
            annexFileUrl:'',
          },
          rules: {
            workNumber: [
              { required: true, message: '请输入活动名称', trigger: 'blur' },
              { min: 6, max: 6, message: '长度在6 个字符', trigger: 'blur' },
              { validator: checkWrited, trigger: 'blur' },
            ],departmentId: [
              { required: true, message: '请选择部门', trigger: 'blur' },
            ],userName: [
              { required: true, message: '请输入名字', trigger: 'blur' },
              { min: 2, max: 20, message: '长度在2-20个字符', trigger: 'blur' }
            ],classAttendence: [
              { required: true, message: '请输入检查出勤及上课情况并提交检查记录/上课出勤率', trigger: 'blur' },
              { validator: check, trigger: 'blur' },
            ],lateAttendence: [
              { required: true, message: '请输入晚自习值班、周周考监考次数/晚自习出勤率', trigger: 'blur' },
              { validator: check, trigger: 'blur' },
            ],dormitoryTimes: [
              { required: true, message: '请输入检查宿舍次数/是否有通报', trigger: 'blur' },
              { validator: check, trigger: 'blur' },
            ],talkRecord: [
              { required: true, message: '请输入联系学生并提交谈话记录', trigger: 'blur' },
              { min: 1, max: 20, message: '长度在1-20个数字', trigger: 'blur' },
             
            ],writeDate: [
              { required: true, message: '请选择时间', trigger: 'blur' },
            ],
            feedback: [
              { required: true, message: '请输入每月学生综合评价好评率', trigger: 'blur' },
              { validator: checkOne, trigger: 'blur' },
            ],
            userComplaint: [
              { required: true, message: '请输入是否有学生/家长投诉', trigger: 'blur' },
              { validator: check, trigger: 'blur' },
            ],annexFileUrl: [
              { required: true, message: '请选择附件', trigger: 'blur' },
            ],
            isWeeks: [
            { required: true, message: '请选择时间', trigger: 'blur' },
            { validator: checkWrited, trigger: 'change' },
            ],
          },

        };
      },
      created(){
        this.getDept()
        this.getYearDateList()
        this.getMonthlIST()
      },
      methods: {        beforeAvatarUpload(file) {
          let isImage=  this.$formateDate.isImageFile(file)
          let isPdf=  this.$formateDate.isPdfFile(file)
           if(isImage||isPdf){
            return true
           }else{
            this.$message.error('只能上传图片和pdf!');
            return false
           }
      },
        handChange(){
          console.log(this.$refs.ruleForm)
         this.$refs.ruleForm.validateField('workNumber')
        },
        workNumberChange(){
          this.$refs.ruleForm.validateField('isWeeks')
        },
        handleRemove(file, fileList) {
          this.fileList = fileList.slice(-3);
        console.log(file, fileList);
      },
      handSuccess(response, file, fileList){
      console.log('fileList',fileList)
      },  handleChange(file, fileList) {
        console.log('handleChange',fileList)
        this.fileList = fileList.slice(-3);
      },
        submitForm(formName) {
          if(this.fileList.length<=0){
            this.parameter.annexFileUrl=null
          }else{
         let files= this.fileList.map(res=>{
              return res.response
            })
            this.parameter.annexFileUrl=JSON.stringify(files)
          }
          if(!(this.value==null||this.value3==''||this.parameter.isWeeks=='')){
            let kpidate=this.value+'-'+(this.value3>9?this.value3:'0'+this.value3)
            this.parameter.writeDate=kpidate
          }else{
            this.parameter.writeDate=null
          }
          this.$refs[formName].validate((valid) => {
            if (valid) {
             
              this.axios.post("/performance/instructor/add",this.parameter).then(res=>{
                if(res.data.status==1){
                  this.$message.success("添加成功");
                  this.resetForm('ruleForm')
                }else{
                  this.$message.error(res.data.message);
                }
              })


            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },getDept(){
          this.axios.get("/performance/getDept")
          .then(resp => { 
            this.deptlist=resp.data
         console.log(resp)
          })
        },  getYearDateList(){
      var date = new Date()
    var Y = date.getFullYear()
    console.log(Y)
   let yearList=[]
   yearList.push(Y-1)
   yearList.push(Y)
   yearList.push(Y+1)
    this.value=Y
   this.year=yearList
       }, isEmptyStr(s) {
	if (s == undefined || s == null || s == '') {
		return true
	}
	return false
},
       getMonthlIST(){
        var date = new Date()
        var M = (date.getMonth() + 1)
        this.value3=M
        let mounList=[]
        for (let index = 1; index <13; index++) {
        mounList.push(index)  
        }
      this.moun=mounList
      // this.value3=M
       },checkCharacter(char) {
        for (let i = 0; i < char.length; i++) {
    const charCode = char[i].charCodeAt(0); // 获取字符的ASCII码值
    if (charCode >= 48 && charCode <= 57) { 
    } else {
      return false
      break;
    }
}
return true
},checkVal(rule, value, callback,va){
  if(rule.field=='lateAttendence'||rule.field=='classAttendence'){
     let value=va[1]
     let charToCheck = "%";
     if(value.includes(charToCheck)){
      va[1]= va[1].replace(new RegExp(charToCheck, 'g'), '');
     }else{
      callback(new Error("/右边未发现%号"))
     }
  }
  if(rule.field=='lateAttendence'||rule.field=='dormitoryTimes'||rule.field=='classAttendence'||rule.field=='userComplaint'){
    if(!this.checkCharacter(va[0])){   callback(new Error("/左边格式不正确，应为数字类型")) }
    if(!this.checkCharacter(va[1])){   callback(new Error("/右边格式不正确，应为数字类型")) }
                callback();
  }
}
      }
    }
  </script>


// WEBPACK FOOTER //
// src/components/work/instructor/LPerformance.vue